module.exports = __webpack_public_path__ + "img/9788995894576.4af29aa2.jpg";